let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lwEwX")).then(() => parcelRequire('gYHNS'));